require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-dj-w-ld.json") })
        }
      }, "path---interview-dj-w-ld");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-dj-w-ld!./.cache/json/interview-dj-w-ld.json
// module id = 669
// module chunks = 231608221292675